<template>
  <div :v-if="visible" class="notifications-alert-container px-4 pb-4">
    <v-alert
      border="left"
      colored-border
      color="red"
      elevation="2"
      key="error-alert"
      class="cursor-pointer px-4 py-4 body-2 blue-grey--text text--darken-3"
      transition="slide-x-transition"
      :value="visible"
    >
      {{ alertText }}
      <template v-slot:append>
        <div class="align-self-start ms-4">
          <v-icon
            color="blue-grey lighten-1"
            size="24"
            @click.stop="$emit('toggle')"
            >mdi-close-circle</v-icon
          >
        </div>
      </template>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'FilterAlert',

  props: {
    visible: { type: Boolean, required: false, default: false },
    text: {
      type: String,
      required: false,
    },
  },
  computed: {
    alertText() {
      return this.text || this.$t('common.alert_text')
    },
  },
}
</script>
<style lang="scss" scoped>
.notifications-alert-container {
  position: fixed;
  top: 64px;
  right: 0;
  max-width: 350px;
  z-index: 2;
  height: auto;
}
</style>
